import React from "react";
import { ImagePlus } from "lucide-react";
import { deliveryApi as _api } from "../../services/deliveryApi"; // eslint-disable-line no-unused-vars
import { resolveBackendImage } from "../../utils/brandLogo";

export const UNIDADES = [
  ["unidade", "Unidade"],
  ["kg", "Kg"],
  ["g", "Grama"],
  ["litro", "Litro"],
  ["ml", "ml"],
  ["duzia", "Dúzia"],
  ["maco", "Maço"],
  ["pote", "Pote"],
  ["pacote", "Pacote"],
  ["caixa", "Caixa"],
];

const TIPOS_PRODUTO = [
  ["artesanal", "Artesanal"],
  ["organico", "Orgânico"],
  ["agroecologico", "Agroecológico"],
  ["industrializado", "Industrializado"],
  ["servico", "Serviço"],
];

const RESTRICOES = [
  ["vegano", "🌱 Vegano"],
  ["vegetariano", "🥗 Vegetariano"],
  ["sem_gluten", "🌾 Sem glúten"],
  ["sem_lactose", "🥛 Sem lactose"],
  ["organico", "🌿 Orgânico"],
  ["agroecologico", "🌾 Agroecológico"],
];

export default function ProdutoFormAbaInfo({
  data, update, setTipoProduto, toggleRestricao,
  categorias, initial, uploading, handlePhotoUpload, handlePhotoDelete,
}) {
  return (
    <div className="space-y-3">
      {/* Foto: só disponível após save inicial */}
      {initial.id ? (
        <div>
          <label className="block text-xs font-medium mb-1">Foto do produto</label>
          <div className="flex items-center gap-3">
            {data.foto_url ? (
              <img
                src={resolveBackendImage(data.foto_url)}
                alt={data.nome}
                className="w-20 h-20 rounded-lg object-cover bg-[var(--bg-secondary)]"
              />
            ) : (
              <div className="w-20 h-20 rounded-lg bg-[var(--bg-secondary)] flex items-center justify-center">
                <ImagePlus className="w-6 h-6 text-[var(--text-secondary)]" />
              </div>
            )}
            <div className="flex-1 space-y-1.5">
              <label
                className="block px-3 py-2 text-xs text-center border border-[var(--border)] rounded-lg cursor-pointer hover:bg-[var(--bg-secondary)]"
                data-testid="delivery-produto-foto-input"
              >
                {uploading ? "Enviando..." : data.foto_url ? "Trocar foto" : "Escolher foto"}
                <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden"
                  onChange={handlePhotoUpload} disabled={uploading} />
              </label>
              {data.foto_url && (
                <button type="button" onClick={handlePhotoDelete}
                  className="block w-full px-3 py-1 text-xs text-red-600 hover:bg-red-50 rounded"
                  data-testid="delivery-produto-foto-delete">
                  Remover
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="text-xs text-[var(--text-secondary)] bg-amber-50 border border-amber-200 rounded p-2">
          Salve o produto primeiro para adicionar uma foto.
        </div>
      )}

      <div>
        <label className="block text-xs font-medium mb-1">Nome *</label>
        <input type="text" value={data.nome}
          onChange={(e) => update({ nome: e.target.value })}
          className="w-full px-3 py-2 border border-[var(--border)] rounded-lg text-sm"
          data-testid="delivery-produto-nome" />
      </div>
      <div>
        <label className="block text-xs font-medium mb-1">Descrição</label>
        <textarea rows={2} value={data.descricao || ""}
          onChange={(e) => update({ descricao: e.target.value })}
          className="w-full px-3 py-2 border border-[var(--border)] rounded-lg text-sm"
          data-testid="delivery-produto-descricao" />
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-xs font-medium mb-1">Preço (R$) *</label>
          <input type="number" step="0.01" min="0" value={data.preco}
            onChange={(e) => update({ preco: e.target.value })}
            className="w-full px-3 py-2 border border-[var(--border)] rounded-lg text-sm"
            data-testid="delivery-produto-preco" />
        </div>
        <div>
          <label className="block text-xs font-medium mb-1">Unidade *</label>
          <select value={data.unidade_medida || "unidade"}
            onChange={(e) => update({ unidade_medida: e.target.value })}
            className="w-full px-3 py-2 border border-[var(--border)] rounded-lg text-sm bg-white"
            data-testid="delivery-produto-unidade">
            {UNIDADES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium mb-1">Categoria</label>
        <select value={data.categoria_id || ""}
          onChange={(e) => update({ categoria_id: e.target.value })}
          className="w-full px-3 py-2 border border-[var(--border)] rounded-lg text-sm bg-white"
          data-testid="delivery-produto-categoria">
          <option value="">— Sem categoria —</option>
          {categorias
            .slice().sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
            .map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      <div>
        <label className="block text-xs font-medium mb-1">Tipo de produto *</label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
          {TIPOS_PRODUTO.map(([v, l]) => (
            <button key={v} type="button"
              onClick={() => setTipoProduto(v)}
              data-testid={`tipo-produto-${v}`}
              className={`px-2 py-1.5 text-xs rounded-lg border ${
                data.tipo_produto === v
                  ? "border-orange-500 bg-orange-50 text-orange-700 font-semibold"
                  : "border-[var(--border)] hover:bg-[var(--bg-secondary)]"
              }`}>{l}</button>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium mb-1">
          Características alimentares (opcional)
        </label>
        <div className="grid grid-cols-2 gap-1.5">
          {RESTRICOES.map(([v, l]) => (
            <label key={v} className="flex items-center gap-1.5 text-xs px-2 py-1.5 border border-[var(--border)] rounded-lg cursor-pointer hover:bg-[var(--bg-secondary)]">
              <input type="checkbox"
                checked={(data.restricoes_alimentares || []).includes(v)}
                onChange={() => toggleRestricao(v)}
                data-testid={`restricao-${v}`} />
              {l}
            </label>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-1.5 pt-1">
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!data.destaque}
            onChange={(e) => update({ destaque: e.target.checked })}
            data-testid="delivery-produto-destaque" />
          Produto em destaque
        </label>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!data.disponivel}
            onChange={(e) => update({ disponivel: e.target.checked })}
            data-testid="delivery-produto-disponivel" />
          Disponível para venda
        </label>
      </div>
    </div>
  );
}
